import CardPrestataireV2 from "../CardPrestataireV2";
import "./styles.css";
export default function SectionListePrestataire({total, listPrestataires, title }) {

    
    return (
        <section className="section-list-presta">
            <h2 className="gold-text">INTERESEAUX</h2>
            <h3 style={{textAlign:"center",fontSize:"1.6em"}}>{title}</h3>
            <div className="list-presta-container">
                {
                    listPrestataires.map((prestataire)=>(
                        
                        <CardPrestataireV2 key={prestataire.idPrestataire} prestataire={prestataire}/>
                        
                    )

                    )
                }
            </div>
        </section>
    )

}